import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage.jsx";
import MenuPage from "./components/MenuPage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer.jsx";
import ClosureNoticeModal from "./components/ClosureNoticeModal.jsx";

function App() {
  return (
    <Router>
      <Navbar />

      <ClosureNoticeModal />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/menu" element={<MenuPage />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
